// extracted by mini-css-extract-plugin
export var address = "styles-module--address--96bdc";
export var container = "styles-module--container--66ec8";
export var details = "styles-module--details--04a33";
export var factLabel = "styles-module--factLabel--a5385";
export var icon = "styles-module--icon--807c6";
export var iconGroup = "styles-module--iconGroup--12888";
export var info = "styles-module--info--39808";
export var membership = "styles-module--membership--78c51";
export var socialLink = "styles-module--socialLink--5123b";